import { cn } from "@app/lib/utils";
import { URLS } from "@app/shared";
import { linksDrawerAtom, searchDrawerAtom } from "@design-system/atoms";
import { Link } from "@design-system/components";
import { useChangeLocaleCode } from "@design-system/hooks";
import {
  ArabicLogoIcon,
  ColoredArabicLogoIcon,
  ColoredLogoIcon,
  LogoIcon,
} from "@design-system/icons";
import {
  ChangeLanguageButton,
  LinksDrawer,
  LinksDrawerButton,
  NavLinks,
  SearchDrawer,
} from "@design-system/layouts/CommonLayout";
import { InvestmentButton } from "@design-system/layouts/CommonLayout/InvestmentButton";

type MainHeaderProps = {
  color?: string;
  className?: string;
};

export function MainHeader({ color, className }: MainHeaderProps) {
  const [searchDrawerAtomOpened, linksDrawerAtomOpened] = [
    searchDrawerAtom.useOpened(),
    linksDrawerAtom.useOpened(),
  ];

  const { currentLocaleCode } = useChangeLocaleCode();

  return (
    <header
      className={cn(
        "sticky top-0 z-[100] w-full max-xl:hidden",
        searchDrawerAtomOpened || linksDrawerAtomOpened
          ? "!bg-white text-dark-blue"
          : "",
        className,
      )}
      style={{
        backgroundColor: color || "#000C2C",
      }}
    >
      <div
        className={cn(
          "container flex items-center justify-between py-8 text-white transition-colors duration-500",
          searchDrawerAtomOpened || linksDrawerAtomOpened
            ? "bg-white text-dark-blue"
            : "",
        )}
      >
        <Link to={URLS.home}>
          {!searchDrawerAtomOpened && !linksDrawerAtomOpened ? (
            <>
              {currentLocaleCode === "en" ? (
                <LogoIcon className="max-2xl:w-44" />
              ) : (
                <ArabicLogoIcon className="max-2xl:w-44" />
              )}
            </>
          ) : (
            <>
              {currentLocaleCode === "en" ? (
                <ColoredLogoIcon className="max-2xl:w-44" />
              ) : (
                <ColoredArabicLogoIcon className="max-2xl:w-44" />
              )}
            </>
          )}
        </Link>
        <NavLinks />
        <div className="flex items-center gap-4">
          <InvestmentButton />
          <ChangeLanguageButton />
          {/* <SearchButton /> */}
          <LinksDrawerButton />
        </div>
      </div>
      <SearchDrawer />
      <LinksDrawer />
    </header>
  );
}
